var map = {
	"./banner": [
		"354e"
	],
	"./banner.vue": [
		"354e"
	],
	"./chat-item": [
		"59ce",
		"chunk-07314da8"
	],
	"./chat-item.vue": [
		"59ce",
		"chunk-07314da8"
	],
	"./footer": [
		"8416"
	],
	"./footer.vue": [
		"8416"
	],
	"./header": [
		"7a54"
	],
	"./header.vue": [
		"7a54"
	],
	"./live-info": [
		"4158"
	],
	"./live-info.vue": [
		"4158"
	],
	"./schedule": [
		"096f",
		"chunk-00a05ed3"
	],
	"./schedule.vue": [
		"096f",
		"chunk-00a05ed3"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "5a1c";
module.exports = webpackAsyncContext;